application.register("layout_header", class extends Stimulus.Controller {
    connect() {
        if (this.element.classList.contains("is--header-invert")) {
            document.documentElement.classList.add("is--header-invert");
        } else {
            document.documentElement.classList.remove("is--header-invert");
        }
    }
});